import React from "react";
import { useLoaderData } from "react-router-dom";
import { enqueueSnackbar, SnackbarProvider } from "notistack";
import currency from "currency.js";
import { Formik } from "formik";
import TransactionDetails from "../../Components/ReviewPage/FormPanel/TransactionDetails/TransactionDetails";
import { Backdrop, Button, CircularProgress, Stack } from "@mui/material";
import { validationSchema } from "../../Components/ReviewPage/FormPanel/FormPanel";
import { CONSUMER_URL } from "../../helpers/variables";

const LineItems = () => {
  const { final_invoice, client_url, responseID, payload } = useLoaderData();

  let { line_items, invoice_amount } = final_invoice;

  const INITIAL_VALUES = {
    invoice_amount,
    line_items,
  };

  /**
   *
   * @param {import("formik").FormikValues} values
   * @param {import("formik").FormikHelpers} formikHelpers
   */
  async function submitForm(values, formikHelpers) {
    let totalAmount = 0;
    values["line_items"].forEach((i) => {
      i["amount"] = currency(i["amount"]).value;
      totalAmount += i["amount"];
    });

    payload["amount"] = currency(totalAmount).value;
    payload["JEID"] = responseID;

    let res = await fetch(
      `${CONSUMER_URL}/update_line_items?client_url=${client_url}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ line_items: values["line_items"], payload }),
      }
    );

    if (res.status == 200) {
      enqueueSnackbar("Successfully updated", { variant: "success" });
      return;
    }
    enqueueSnackbar(await res.text(), { variant: "error" });
  }

  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Formik
        initialValues={INITIAL_VALUES}
        onSubmit={submitForm}
        validationSchema={validationSchema.pick(["line_items"])}
      >
        {({ handleSubmit, isSubmitting, errors }) => (
          <Stack gap={1} component={"form"} onSubmit={handleSubmit}>
            <TransactionDetails nimbleIntegration />
            <Stack
              alignItems={"center"}
              position={"sticky"}
              bottom={0}
              zIndex={2}
              bgcolor={"white"}
              p={1}
            >
              <Button type="submit" variant="contained" color="success">
                Submit
              </Button>
            </Stack>
            <Backdrop
              open={isSubmitting}
              sx={{ zIndex: (theme) => theme.zIndex.appBar }}
            >
              <CircularProgress />
            </Backdrop>
          </Stack>
        )}
      </Formik>
    </SnackbarProvider>
  );
};

export default LineItems;
